import PageWithTitleMixin from 'mixins/PageWithTitleMixin'

export const steps = [
    { path: 'search', view: 'Search' },
    { path: 'results', view: 'ResultsRouter' },
    { path: 'make', view: 'Make' },
]

export default {
    mixins: [PageWithTitleMixin],

    computed: {
        pageTitle() {
            return this.$t('pages.referrals.new.title')
        },

        stepIndex() {
            return steps.findIndex((step) => step.path === this.$route.params.step)
        },

        pageBreadcrumbs() {
            return steps.reduce((breadcrumbs, step, index) => {
                return index <= this.stepIndex
                    ? breadcrumbs.concat([
                          {
                              label: this.$t(`pages.referrals.new.breadcrumbs.${step.path}`),
                              route:
                                  index !== this.stepIndex
                                      ? {
                                            name: `pool.new.${step.path}`,
                                            query: this.$route.params.originalQuery || this.$route.query,
                                        }
                                      : undefined,
                          },
                      ])
                    : breadcrumbs
            }, [])
        },
    },

    methods: {
        goToNextStep() {
            this.$router.push({ name: `pool.new.${steps[this.stepIndex + 1].path}` })
        },
    },
}
